<template>
  <button class="button-scroll" @click="scrollToNextSection">
    <svg>
      <use xlink:href="#scrollDownSvg"></use>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ScrollToNext',
  props: ['dark'],
  data () {
    return {
      windowHeight: 0
    }
  },
  methods: {
    scrollToNextSection () {
      this.scrollToY(this.windowHeight, 1500, 'easeInOutQuint')
    },
    scrollToY (scrollTargetY = 0, speed = 2000, easing = 'easeOutSine') {
      let scrollY = window.pageYOffset
      let currentTime = 0

      let time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8))

      let easingEquations = {
        easeOutSine: function (pos) {
          return Math.sin(pos * (Math.PI / 2))
        },
        easeInOutSine: function (pos) {
          return (-0.5 * (Math.cos(Math.PI * pos) - 1))
        },
        easeInOutQuint: function (pos) {
          if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(pos, 5)
          }
          return 0.5 * (Math.pow((pos - 2), 5) + 2)
        }
      }
      function tick () {
        currentTime += 1 / 60
        let p = currentTime / time
        let t = easingEquations[easing](p)
        if (p < 1) {
          window.requestAnimFrame(tick)
          window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t))
        } else {
          window.scrollTo(0, scrollTargetY)
        }
      }
      tick()
    }
  },
  mounted () {
    this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.documentElement.getElementsByTagName('body')[0].clientHeight
  }
}
</script>

<style scoped lang="scss">
</style>
